import { UnitValue } from '../../../models/data-structures/unit-value.model';
import { ProjectValidationUnit } from '../../../models/data-structures/project-validation';
import Utils from '../../../util';
import { ValidationInterface } from '../validation.interface';

export class UnitValueValidation implements ValidationInterface {
  /** The current unit value obj that is being validated */
  unitValue: UnitValue;

  /**
   * Sets the unit value obj that will be used for validation
   * @param unitValue will be used to set the current unit value obj
   */
  constructor(unitValue: UnitValue) {
    if (!unitValue) throw Error('unable to validate unit value');
    this.unitValue = new UnitValue(unitValue);
  }

  /**
   * Get a validation unit containing the validation data for the current unit value obj
   */
  getValidation(): ProjectValidationUnit {
    const validationUnit = new ProjectValidationUnit();
    const valueErrors = this.getValueErrors();
    if (valueErrors.length > 0) {
      validationUnit.setInvalid('INPUT_SUMMARY.TABLE_HEADERS.VALUE', valueErrors);
    } else {
      validationUnit.setValid('INPUT_SUMMARY.TABLE_HEADERS.VALUE');
    }
    const unitErrors = this.getUnitErrors();
    if (unitErrors.length > 0) {
      validationUnit.setInvalid('INPUT_SUMMARY.TABLE_HEADERS.UNIT', unitErrors);
    } else {
      validationUnit.setValid('INPUT_SUMMARY.TABLE_HEADERS.UNIT');
    }
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current unit value obj is valid
   */
  isValid(): boolean {
    const validationUnit = this.getValidation();
    return validationUnit.isValid;
  }

  /**
   * Returns true if a TS or VS unit value is valid else false
   */
  isTSVSValid(): boolean {
    const percentages = ['000000000000000000000101', '000000000000000000006301'];
    const gramProportions = ['000000000000000000000102', '000000000000000000006302'];
    const poundProportions = ['000000000000000000000103', '000000000000000000006303'];
    if(!this.unitValue.hasValues()) return false;
    if(this.unitValue.value <= 0) return false;
    if(percentages.includes(this.unitValue.unit)) return this.unitValue.value <= 100.0;
    if(gramProportions.includes(this.unitValue.unit)) return this.unitValue.value <= 1000.0;
    if(poundProportions.includes(this.unitValue.unit)) return this.unitValue.value <= 2000.0;
    return false;
  }

  /**
   * Returns an array of errors for the current unit value's value
   */
  private getValueErrors(): string[] {
    const valueErrors = [];
    // ids of percent units from the database
    const percentageUnits: string[] = [
      '000000000000000000000101',
      '000000000000000000000201',
      '000000000000000000000301',
      '000000000000000000001502',
      '000000000000000000001801',
      '000000000000000000002101',
      '000000000000000000002102',
      '000000000000000000002201',
    ];
    if (this.unitValue.value === null || this.unitValue.value === undefined) {
      valueErrors.push('VALIDATION.MISSING_VALUE');
    } else if (!Utils.isNumeric(this.unitValue.value)) {
      valueErrors.push('VALIDATION.NOT_A_NUMBER');
    }
    // if (this.value < 0) {
    //   valueErrors.push('value cannot be less than 0');
    // }
    if (this.unitValue.unit && percentageUnits.includes(this.unitValue.unit) && this.unitValue.value > 100) {
      valueErrors.push('VALIDATION.OVER_100');
    }
    return valueErrors;
  }

  /**
   * Returns an array of errors for the current unit value's unit
   */
  private getUnitErrors() {
    const unitErrors = [];
    if (!this.unitValue.unit) {
      unitErrors.push('VALIDATION.MISSING_UNIT');
    }
    return unitErrors;
  }
}
